import type { ArticleParagraphComponent } from '@twisto/api-cms'

import type { RichTextBlock } from 'homepage/components/rich-text/rich-text.d'

import { RichText } from '../../rich-text'

import * as styles from './paragraph.styles'

type Props = ArticleParagraphComponent & { text?: RichTextBlock[] }

export const Paragraph = ({ text }: Props) => (
  <RichText css={styles.paragraph} input={text} />
)
